import { Link } from 'react-router-dom';

const TONES = {
  neutral: 'border-neutral-200 dark:border-neutral-800',
  action: 'border-accent',
  ready: 'border-success',
  danger: 'border-danger',
};

const VALUE_TONES = {
  neutral: 'text-neutral-950 dark:text-white',
  action: 'text-accent',
  ready: 'text-success',
  danger: 'text-danger',
};

export default function OrdersMetricCard({ label, value, description, tone = 'neutral', to }) {
  const className = [
    'block min-h-[8.25rem] rounded-xl border bg-white p-4 text-left shadow-[0_1px_2px_rgba(15,23,42,0.035)]',
    'dark:bg-neutral-900',
    TONES[tone] || TONES.neutral,
    to ? 'transition hover:-translate-y-px hover:shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus' : '',
  ].join(' ');
  const content = (
    <>
      <p className="text-[11px] font-semibold uppercase tracking-[0.09em] text-neutral-500 dark:text-neutral-400">{label}</p>
      <p className={`mt-2 text-3xl font-semibold tracking-[-0.035em] tabular-nums ${VALUE_TONES[tone] || VALUE_TONES.neutral}`}>{value}</p>
      <p className="mt-2 text-xs leading-5 text-neutral-500 dark:text-neutral-400">{description}</p>
    </>
  );
  return to ? <Link to={to} className={className}>{content}</Link> : <div className={className}>{content}</div>;
}
